import {createTheme} from "@mui/material";
// Define a custom theme for Material-UI
export const theme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  palette: {
    primary: {
      main: '#2463eb', // --color-1
      light: '#508df7', // --color-2
    },
    secondary: {
      main: '#cbd5e1', // slate-300 (keeping existing neutral secondary)
    },
    background: {
      default: 'linear-gradient(to right, #6a11cb 0%, #2575fc 100%)', // Keeping existing background
    },
    text: {
      primary: '#334155', // Dark text for titles and main content
      secondary: '#475569', // Slightly lighter dark text for descriptions
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '0.75rem', // rounded-xl
          fontWeight: 600, // font-semibold
          padding: '0.75rem 1.5rem', // py-3 px-6
          transition: 'background-color 0.3s ease-in-out',
          textTransform: 'none', // Keep text as is, not all caps
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '1rem', // rounded-xl
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)', // shadow-md
          transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
          border: '1px solid #e2e8f0', // slate-200
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)', // shadow-lg
          },
        },
      },
    },
  },
});